import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class AwarenessOfIms extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            currentUser={this.props.currentUser}
            contentName={'awarenessOfIms'}
            title={'PROCEDURE P6.0 AWARENESS OF ISMS DOCUMENTATION'}
            exportTitle={'<h2>Procedure P6.0 Awareness of ISMS Documentation</h2>'}
            exportFileName={'awareness_of_ims.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (AwarenessOfIms);